// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detail-list-dialog-wrap[data-v-377618ba] {\n  padding: 35px 45px;\n}\n.detail-list-dialog-wrap .line[data-v-377618ba] {\n    width: 1px;\n    height: 16px;\n    margin: 0 20px;\n    background: #E0E0E0;\n}\n.detail-list-dialog-wrap .list-bottom[data-v-377618ba] {\n    border-bottom: 1px solid #E0E0E0;\n}\n", ""]);
// Exports
module.exports = exports;
